import React, { useRef, useEffect, useState } from 'react';

const ProjectCardMobile = ({ wrapperClass, hoverConfig, mobileHoverConfig, textConfig, linkTo }) => {
  const config = mobileHoverConfig || hoverConfig;
  const containerRef = useRef(null);
  const effectRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (containerRef.current && window.hoverEffect) {
      const timer = setTimeout(() => {
        try {
          const canvas = containerRef.current.querySelector('canvas');
          if (canvas) canvas.remove();

          effectRef.current = new window.hoverEffect({
            parent: containerRef.current,
            intensity: config.intensity,
            image1: config.image1,
            image2: config.image2,
            displacementImage: config.displacementImage,
            imagesRatio: 1,
            hover: false
          });
        } catch (error) {
          console.error('Error creating hover effect for', wrapperClass, error);
        }
      }, 100);

      return () => {
        clearTimeout(timer);
        if (containerRef.current) {
          const canvas = containerRef.current.querySelector('canvas');
          if (canvas) canvas.remove();
        }
      };
    }
  }, [config, wrapperClass]);

  // Alternance automatique toutes les 3 secondes
  useEffect(() => {
    const interval = setInterval(() => {
      setActive(prev => {
        const next = !prev;
        if (effectRef.current) {
          if (next) {
            effectRef.current.next?.();
          } else {
            effectRef.current.previous?.();
          }
        }
        return next;
      });
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  return (
    <a href={linkTo} className="pgm-card-link">
      <div className={`pgm-card ${wrapperClass}${active ? ' pgm-card--active' : ''}`}>
        {/* Image hover */}
        <div ref={containerRef} className="pgm-card-image" />

        {/* Texte superposé en bas */}
        <div className="pgm-card-text">
          <p className={`pgm-card-title ${textConfig.titleClass}`}>
            {textConfig.title}
          </p>
          <div className={`pgm-card-infos ${textConfig.textClass}`}>
            {textConfig.texts.map((t, i) => (
              <p key={i}>{t}</p>
            ))}
          </div>
        </div>
      </div>
    </a>
  );
};

export default ProjectCardMobile;